module.exports = __webpack_public_path__ + "img/video-a1.a59f5bc2.jpg";